import { render } from "./text.vue?vue&type=template&id=afc02076&scoped=true"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-afc02076"

export default script